import { useCallback, useMemo } from 'react'

import { useAtom } from 'jotai'

import { sidePanelLayoutStore } from 'src/stores/sidePanelLayoutStore'

export const useSidePanelLayout = () => {
  const [storeValue, setStoreValue] = useAtom(sidePanelLayoutStore.state)

  const isOpened = useMemo(() => storeValue.state === 'opened', [storeValue.state])

  // NOTE: サイドパネルの状態もクエリパラメータベースで管理するようになった場合、この下の関数自体削除になる可能性あり

  const showSidePanel = useCallback(() => {
    setStoreValue({
      state: 'opened',
    })
  }, [setStoreValue])

  const hideSidePanel = useCallback(() => {
    setStoreValue({
      state: 'closed',
    })
  }, [setStoreValue])

  return {
    isOpened,
    showSidePanel,
    hideSidePanel,
  }
}
